import React from 'react';
import { Link } from 'react-router-dom';
import classes from './category-showcase.module.scss';

const CategoryShowcase = () => {
    const showcaseData = (window.categoryShowcase) || [];
    return (
        <section className={classes.categoryShowcase}>
            <div className={classes.grid}>
                {showcaseData.map((item, index) => (
                    <div
                        className={`${classes.item_row} ${item.reverse ? classes.rowReverse : ''}`}
                        key={index}
                    >
                        <div className={classes.text}>
                            <div className={classes.textInner}>
                                <h2 className={`${classes.title} uk-padding-remove`}>
                                    {item.title}
                                </h2>
                                <p className={classes.description}>
                                    {item.description}
                                </p>
                                <Link
                                    to={`${process.env.PUBLIC_URL}${item.link}`}
                                    className={classes.btn}
                                >
                                    {item.buttonText}
                                </Link>
                            </div>
                        </div>
                        <Link to={`${process.env.PUBLIC_URL}${item.link}`} className={classes.image}>
                            <figure>
                                <img
                                    src={item.image}
                                    alt={item.buttonText}
                                    loading="lazy"
                                />
                            </figure>
                        </Link>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default CategoryShowcase;
